import { render, staticRenderFns } from "./diagnostic-chart.vue?vue&type=template&id=c2f79222&"
import script from "./diagnostic-chart.vue.js?vue&type=script&lang=js&"
export * from "./diagnostic-chart.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports